// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pYTU","type":"styles_type__xaWV5","choices":"styles_choices__1OLCM"};